import React from "react";
import FlipMove from "react-flip-move";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { deleteCartItem } from "../redux/actionCreators";
import CartItemBox from "../CartItemBox";
import CartItemContainer from "../CartItemContainer";
import CartItemRow from "../CartItemRow";
import LeadingText from "../LeadingText";
import FloatingActionButton from "../FloatingActionButton";
import { ArrowRight, NoData } from "../Icons";
import SupportingText from "../SupportingText";
import { formatPrice } from "../helpers";

const sum = (a, b) => a + b;

const mapStateToProps = ({ cart, auth }) => {
  const isLoggedIn = auth.authStatus.indication === "loaded";
  return {
    cartItems: cart.cartItems,
    cartTotal: isLoggedIn
      ? cart.cartItems.map(el => el.price).reduce(sum, 0)
      : 0,
    isLoggedIn
  };
};

const mapDispatchToProps = dispatch => ({
  onCartItemDelete: article => dispatch(deleteCartItem(article))
});

function CartBottom({ cartTotal, isLoggedIn }) {
  return (
    <div className="w-full absolute pin-l pin-b border-t border-grey-light">
      <div
        style={{
          height: "60px"
        }}
        className="flex items-center justify-between"
      >
        <div className="w-2/3 flex items-center justify-start">
          <div className="pr-2">
            <SupportingText textColor="black" textSize="base">
              Total:
            </SupportingText>
          </div>
          <SupportingText
            textColor="red-light"
            fontWeight="normal"
            textSize="lg"
          >
            {formatPrice(cartTotal)} €
          </SupportingText>
        </div>
        <div className="w-1/3">
          <Link
            to={{
              pathname: isLoggedIn ? "/checkout" : "/profile",
              state: { from: "/cart" }
            }}
          >
            <div className="flex items-center justify-between">
              <SupportingText textSize="base" textColor="black">
                Zur Kasse
              </SupportingText>
              <FloatingActionButton bgColor="red-lightest" size="xs">
                <ArrowRight stroke="#EF5753" height="15px" />
              </FloatingActionButton>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}

function CartView({ isLoggedIn, cartItems, cartTotal, onCartItemDelete }) {
  return (
    <div className="h-full">
      {cartItems.length ? (
        <div
          className="w-full h-full"
          style={{
            paddingBottom: "60px"
          }}
        >
          <div
            style={{
              height: "10%"
            }}
            className="w-full flex items-center justify-center py-3"
          >
            <LeadingText
              textColor="grey-darkest"
              fontWeight="medium"
              textAlign="center"
            >
              Warenkorb
            </LeadingText>
          </div>
          <CartItemContainer>
            <FlipMove
              duration={300}
              easing="ease-out"
              leaveAnimation="accordionVertical"
            >
              {cartItems.map(item => (
                <CartItemBox key={item.articleID}>
                  <CartItemRow
                    isLoggedIn={isLoggedIn}
                    {...item}
                    onClick={() => {
                      onCartItemDelete(item);
                    }}
                  />
                </CartItemBox>
              ))}
            </FlipMove>
          </CartItemContainer>

          <CartBottom cartTotal={cartTotal} isLoggedIn={isLoggedIn} />
        </div>
      ) : (
        <div className="h-full flex flex-col justify-center items-center">
          <NoData width="200" height="150" />
          <div className="py-4">
            <LeadingText
              textSize="1xl"
              textColor="blue-darker"
              fontWeight="hairline"
            >
              Ihr Warenkorb ist leer.
            </LeadingText>
          </div>
        </div>
      )}
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CartView);



// WEBPACK FOOTER //
// ./src/CartView/CartView.js